// extracted by mini-css-extract-plugin
export var dropdownContainer = "_or-0";
export var leftAlign = "_or-4";
export var listItem = "_or-2";
export var listItemWrapper = "_or-1";
export var operationText = "_or-3";